import type {z} from "zod";

import {createValidationIssue, requiredFieldValidation} from "@project/i18n";
import {EditTaskBody} from "@project/sdk/admin/zod";
import {z as zod} from "zod";

import {taskFieldLabelIds} from "../../messages/tasks.messages";

const baseEditTaskTitleSchema = EditTaskBody.shape.title.unwrap();

export const editTaskTitleSchema = zod.string().superRefine((value, ctx) => {
  if (!value.trim()) {
    ctx.addIssue(createValidationIssue(requiredFieldValidation(taskFieldLabelIds.title)));

    return;
  }

  const result = baseEditTaskTitleSchema.safeParse(value);

  if (!result.success) {
    for (const issue of result.error.issues) {
      ctx.addIssue({...issue});
    }
  }
});

export const editTaskRichSchema = EditTaskBody.extend({
  title: editTaskTitleSchema.optional(),
});
export type EditTaskFormPayload = z.infer<typeof editTaskRichSchema>;
